import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

import data from '../data.json';
import { LazyLoadImage } from 'react-lazy-load-image-component';




function casexperiences() {
  const tabs = [
    { title: 'Yoga', content: () => <div>

    <div className='cam-lower-sec'>
       <h1 className='title'>
       CAS Activity: Yoga</h1>
    </div>

    <div className='photo-sec'>
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-1.webp`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-1.webp
`}></img>
        </Link>
      </div>
    
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-2.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-2.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-3.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-3.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-4.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-4.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-5.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-5.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-6.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-6.webp
`}></img>
        </Link>
      </div>
     
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-7.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-7.webp
`}></img>
        </Link>
      </div>
     
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-8.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-8.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-9.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-9.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-10.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-10.webp
`}></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-11.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Yoga/CAS%20Yoga-11.webp
`}></img>
        </Link>
      </div>
      
      </div>
      </div>
      },
    { title: 'Earth Day', content: () => <div>

    <div className='cam-lower-sec'>
       <h1 className='title'>
       CAS Activity: Earth Day</h1>
    </div>

    <div className='photo-sec'>


      <div className='photo-box'>
  <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-01.webp
`} target="_blank" rel="noopener noreferrer">
  
    <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-01.webp
`} alt="Earth Day" />
  </Link>
</div>


      {/* <div className='photo-box'>
      <Link to="../img/Cas/Earth Day/cas-earth-day-01.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Cas/Earth Day/cas-earth-day-01.webp'></img>
        </Link>
      </div> */}
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-02.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-02.webp`}></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-03.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-03.webp
`}></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-04.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-04.webp
`}></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-05.webp
`}
          target="_blank"
          rel="noopener noreferrer">
         <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Earth%20Day/Earth%20Day/cas-earth-day-05.webp
`}></img>
        </Link>
      </div>
      
      
      </div>
      </div>
      },
      { title: 'Deeply Seeded', content: () => <div>

        <div className='cam-lower-sec'>
           <h1 className='title'>CAS Activity: Deeply Seeded</h1>
        </div>
    
        <div className='photo-sec'>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-01.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-01.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-002.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-002.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-0002.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-0002.webp
`}></img>
            </Link>
          </div>
        
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-02.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-02.webp
`}></img>
            </Link>
          </div>
         
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-03.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-03.webp
`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-04.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-04.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-05.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-05.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-06.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-06.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-07.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-07.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-08.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-08.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-09.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-09.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-10.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-10.webp
`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-11.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Deeply%20Seeded/img-11.webp
`}></img>
            </Link>
          </div>


          </div>
          </div>
      },

      { title: 'Martial Arts', content: () => <div>

        <div className='cam-lower-sec'>
           <h1 className='title'>CAS Activity: Martial Arts</h1>
        </div>
    
        <div className='photo-sec'>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-1.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-1.webp

`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-2.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-2.webp
`}></img>
            </Link>
          </div>
      
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-3.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-3.webp
`}></img>
            </Link>
          </div>
         
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-4.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-4.webp
`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-5.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-5.webp
`}></img>
            </Link>
          </div>
       
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-6.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-6.webp
`}></img>
            </Link>
          </div>
        
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-7.webp
`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Martial%20Arts/CAS%20Martial%20Arts%202023-7.webp
`}></img>
            </Link>
          </div>

          </div>
          </div>
      },
      { title: 'International Labour Day', content: () => <div>

        <div className='cam-lower-sec'>
           <h1 className='title'>CAS Activity: International Labour Day</h1>
        </div>
    
        <div className='photo-sec'>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img01.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img01.webp`}></img>
            </Link>
          </div>
        
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img02.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img02.webp`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img03.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img03.webp`}></img>
            </Link>
          </div>
         
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img04.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img04.webp`}></img>
            </Link>
          </div>
         
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img005.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img005.webp`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img05.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img05.webp`}></img>
            </Link>
          </div>
          
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img06.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img06.webp`}></img>
            </Link>
          </div>
         
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img07.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img07.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img08.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img08.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img09.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img09.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img10.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img10.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img11.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img11.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img12.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img12.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img13.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img13.webp`}></img>
            </Link>
          </div>
          <div className='photo-box'>
          <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img14.webp`}
              target="_blank"
              rel="noopener noreferrer">
             <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Labour%20Day/2026/img14.webp`}></img>
            </Link>
          </div>
        
        </div>
        </div>
        },
        {
          title: 'My Mood Mailbox', content: () => <div>
            <div className='cam-lower-sec'>
             <h1 className='title'>My Mood Mailbox</h1>
          </div>

             <div className='photo-sec'>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img01.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img01.webp
`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img02.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img02.webp
`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img03.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img03.webp
`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img04.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img04.webp
`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img05.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img05.webp
`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img06.webp
`}
                target="_blank" 
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/My%20Mood%20Mailbox/img06.webp
`}></img>
              </Link> 
            </div>
            </div>

          </div>
        },
        { title: 'Bird Feeder and Seed Bombs', content: () => <div>

          <div className='cam-lower-sec'>
             <h1 className='title'>CAS Activity: Bird Feeder and Seed Bombs</h1>
          </div>
      
          <div className='photo-sec'>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/1.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/1.webp`}></img>
              </Link>
            </div>
            
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/2.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/2.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/3.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/3.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/4.webp`}                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/4.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/5.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/5.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/6.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/6.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/7.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/7.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/8.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/8.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/9.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/9.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/10.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/10.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/11.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/11.webp`}></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/12.webp`}
                target="_blank"
                rel="noopener noreferrer">
               <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Bird%20Feeder%20and%20Seed%20Bombs/12.webp`}></img>
              </Link>
            </div>
            </div>
            </div>
            },
      

            { title: 'World Environment Day', content: () => <div>

              <div className='cam-lower-sec'>
                 <h1 className='title'>CAS Activity: World Environment Day</h1>
              </div>
          
              <div className='photo-sec'>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-1.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-1.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-2.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-2.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-3.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-3.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-4.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-4.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-5.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-5.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-6.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-6.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-7.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-7.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-8.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-8.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-9.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-9.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-10.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-10.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-11.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-11.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-12.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-12.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-13.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-13.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-14.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-14.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-15.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-15.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-16.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-16.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-17.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-17.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-18.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-18.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-19.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-19.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-20.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-20.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-21.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-21.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-22.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-22.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-23.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-23.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-24.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-24.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-25.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-25.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-26.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-26.webp`}></img>
                  </Link>
                </div>
                <div className='photo-box'>
                <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-27.webp`}
                    target="_blank"
                    rel="noopener noreferrer">
                   <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/World%20Environment%20Day/World%20Environment%20Day%202021-27.webp`}></img>
                  </Link>
                </div>

                </div>
                </div>
                },

                { title: 'Basketball', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>CAS Activity: Basketball</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-01.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-01.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-02.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-02.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-03.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-03.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-04.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-04.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-05.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-05.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-06.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-06.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-07.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-07.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-08.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-08.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-09.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-09.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-10.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-10.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-11.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-11.webp`}></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-12.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-12.webp`}></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-13.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-13.webp`}></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-14.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-14.webp`}></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-15.webp`}
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/public/img/Cas/Basketball/img-15.webp`}></img>
                      </Link>
                    </div>

                    </div>
                    </div>
                },
                
                
               { title: 'MUN', content: () => (
    <div>
      <div className='cam-lower-sec'>
         <h1 className='title'>MUN</h1>
      </div>
      <div className="photo-sec">
          {data.Events.MUN.map((person) => (
 
              <div key={person.id} className="photo-box">
                <Link 
                  to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoadImage 
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                    alt={person.alt} 
                  />
                </Link>
              </div>
 
          ))}
      </div>
    </div>
  )
},
                { title: 'TOK', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>TOK</h1>
                  </div>
                    <div className="photo-sec">
                        {data.Events.Tok.map((person) => (
              
                          <div key={person.id} className="photo-box">
                            <Link 
                              to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`}
                              target="_blank"
                              rel="noopener noreferrer">
                              <LazyLoadImage 
                              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                              alt={person.alt}/>
                            </Link>
                          </div>
              
                        ))}
                      </div>
              

                
                  </div>
                },
                
                { title: 'Scientific Minds (Atal Tinkering Lab)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Scientific Minds (Atal Tinkering Lab)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Arjun -1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Arjun -1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Arjun -2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Arjun -2.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Atal lab-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Atal lab-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Atal lab-2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Atal lab-2.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Atal lab-3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Atal lab-3.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Atal lab-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Atal lab-4.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Atal Tinkering Lab/Kushagra Swaroop.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Atal Tinkering Lab/Kushagra Swaroop.webp'></img>
                      </Link>
                    </div>
                
                  
                
                 
                   
                    </div>
                    </div>
                },
                
                { title: 'Plantation Drive', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Services (Plantation Drive)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-2.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-3.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-4.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-5.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-6.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-6.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-7.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-7.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-8.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-8.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-9.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-9.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-10.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-11.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-12.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-12.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-13.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-13.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-14.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-14.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-15.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-15.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-16.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-16.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-17.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-17.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-18.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-18.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-19.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-19.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-20.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-20.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-21.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-21.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-22.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-22.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-23.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-23.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-24.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-24.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-25.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-25.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-26.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-26.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-27.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-27.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-28.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-28.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-29.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-29.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-30.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-30.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Plantation Drive/Plantation Drive-31.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Plantation Drive/Plantation Drive-31.webp'></img>
                      </Link>
                    </div>
                
                   
                    </div>
                    </div>
                },

                { title: 'Audiobook released on World Disability Day', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Services (Audiobook released on World Disability Day)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-2.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-3.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-4.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-5.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-6.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-6.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-7.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-7.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-8.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-8.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/Cas/Audiobook released on World Disability Day/AudioBook-9.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Audiobook released on World Disability Day/AudioBook-9.webp'></img>
                      </Link>
                    </div>
                
                </div>
                </div>


                },
                { title: 'Signature Campaign by Disha Foundation', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Services (Signature Campaign by Disha Foundation)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-1.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-2.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-3.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-4.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-5.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-6.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-6.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-7.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-7.webp'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-8.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-8.webp'></img>
                      </Link>
                    </div>
                
                
                    <div className='photo-box'>
                    <Link to="../img/Cas/Disha Foundation/Disha-9.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Disha Foundation/Disha-9.webp'></img>
                      </Link>
                    </div>
                
                  
                </div>
                </div>


                },
                { title: 'Jagriti', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Jagriti</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti01.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti01.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti02.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti02.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti03.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti03.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti04.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti04.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti05.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti05.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti06.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti06.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti07.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti07.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Jagriti/2025/Jagriti08.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Jagriti/2025/Jagriti08.jpeg'></img>
                      </Link>
                    </div>
                  
            
                  
                   

                    </div>
                    </div>
                },
                { title: 'Food Donation', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Food Donation (Akshay Patra)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak01.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak02.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak03.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak04.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak05.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak06.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak07.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak07.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Akshya-Patra/ak08.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Akshya-Patra/ak08.webp'></img>
                      </Link>
                    </div>

                    </div>
                    <br/>
                     <div className='cam-lower-sec'>
                     <h1 className='title'>Food Donation (Arihant Foundation)</h1>
                  </div>

                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari01.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari02.webp'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari03.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari04.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari05.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari06.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari07.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari07.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari08.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari08.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari09.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari09.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari10.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Arihant-Foun/ari11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Arihant-Foun/ari11.webp'></img>
                      </Link>
                    </div>
        
                    </div>
                    
                    <br/>
                     <div className='cam-lower-sec'>
                     <h1 className='title'>Food Donation (Nivala by Kumalabai Charitable Turst)</h1>
                  </div>

                   <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv01.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv02.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv03.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv04.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv05.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv06.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv07.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv07.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv08.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv08.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv09.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv09.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv10.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv11.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Nivala/Niv12.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Nivala/Niv12.webp'></img>
                      </Link>
                    </div>

                    </div>

                    <br/>

                     <div className='cam-lower-sec'>
                     <h1 className='title'>Food Donation (Matrachhaya)</h1>
                  </div>

                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra01.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra02.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra03.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra04.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra05.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra06.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Fooddonation/Matrachhaya/Matra07.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Fooddonation/Matrachhaya/Matra07.webp'></img>
                      </Link>
                    </div>

                    </div>






                  </div>

                },
                { title: 'Donation', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Services (Donation)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/Cas/Donation/donation-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Donation/donation-1.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Donation/donation-2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Donation/donation-2.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Donation/donation-3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Donation/donation-3.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Donation/donation-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Donation/donation-4.webp'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/Cas/Donation/donation-5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/Cas/Donation/donation-5.webp'></img>
                      </Link>
                    </div>
                  
                   
                  
                   

                    </div>
                    </div>
                }
                

                



          ]

    
  return (
    <div>
    <div className='ibdp-hero-sec'>
       <img src='newimg/Deeply Seeded-13.webp'/>

     </div>
     <div className="newsletter-sec">
     <HorizontalTabs tabs={tabs} />
     </div>


   </div> 
  )
}

export default casexperiences
